import React, { Fragment } from 'react';

import { useTranslation } from 'react-i18next';
import extend from 'lodash/extend';

interface Props {
	text: string;
	args?: Record<string, unknown>;
	defaultValue?: string;
}

const Translate = ({ text, args = {}, defaultValue }: Props) => {
	const { t } = useTranslation();
	const tOptions = extend({ defaultValue }, args);

	return <Fragment>{t(text, tOptions)}</Fragment>;
};

export default Translate;
